import { ROUTER_PROCESSOR_ADDRESS } from "@emberswap/emberswap-sdk2/dist/constants"
import { Amount } from "@emberswap/emberswap-sdk2/dist/entities"
import { Type } from "@emberswap/emberswap-sdk2/dist/types"
import { FC } from "react"

import { WrapType } from "../../hooks/useWrapCallback"
import { useSettings } from "../../state/user/hooks"
import Button from "../Button"
import { Checker } from "../Checker"
import { SwapReviewModalLegacy, WrapReviewModal } from "../SwapReviewModal"
import { SButton } from "./SwapButton"


export const SwapButton: FC<{
  recipient: string | undefined
  onSuccess(): void
  recipientActive: boolean
  chainId: number
  parsedInput0: Amount<Type> | undefined
  parsedInput1: Amount<Type> | undefined
  amounts: (Amount<Type> | undefined)[]
  isWrap: boolean
  wrap: boolean
}> = ({
  recipient,
  onSuccess,
  recipientActive,
  chainId,
  parsedInput0,
  parsedInput1,
  amounts,
  isWrap,
  wrap,
}) => {
    const [{ userExpertMode, slippageToleranceType, userSlippageTolerance }, {}] =
      useSettings(chainId)
  return (
    <div className="grid gap-3 p-3 pt-0">
      <Checker.Connected fullWidth size="md" color="gray" variant="filled" rounded="none">
        <Checker.Network fullWidth size="md" chainId={chainId}>
          <Checker.Amounts variant="outlined" color="green" fullWidth size="md" amounts={amounts}>
            <Checker.ApproveERC20
              onSuccess={onSuccess}
              id="approve-erc20"
              amount={parsedInput0}
              contract={ROUTER_PROCESSOR_ADDRESS[chainId]}
            >
              {isWrap ? (
                <WrapReviewModal
                  id="swap-wrap-review-modal"
                  chainId={chainId}
                  input0={parsedInput0}
                  input1={parsedInput1}
                  wrapType={wrap ? WrapType.Wrap : WrapType.Unwrap}
                >
                  {({ isWritePending, setOpen }) => {
                    return (
                      <Button
                        testdata-id={'open-wrap-review-modal-button'}
                        disabled={isWritePending}
                        fullWidth
                        color="gray"
                        variant="filled"
                        size="lg"
                        onClick={() => setOpen(true)}
                      >
                        {wrap ? 'Wrap' : 'Unwrap'}
                      </Button>
                    )
                  }}
                </WrapReviewModal>
              ) : (
                <SwapReviewModalLegacy
                  recipient={recipient}
                  chainId={chainId}
                  onSuccess={onSuccess}
                >
                  {({ setOpen }) => {
                    return (
                      <SButton
                        recipient={recipient}
                        userExpertMode={userExpertMode}
                        recipientActive={recipientActive}
                        userSlippageTolerance={userSlippageTolerance}
                        slippageToleranceType={slippageToleranceType}
                        setOpen={setOpen}
                      />
                    )
                  }}
                </SwapReviewModalLegacy>
              )}
            </Checker.ApproveERC20>
          </Checker.Amounts>
        </Checker.Network>
      </Checker.Connected>
    </div>
  )
}
